export default {
    es: {
        htmlViewer: {
            title: 'Contenido de usuario',
            createdBy: 'Este archivo HTML fue creado por',
            modifiedBy: 'y modificado por',
            warning: 'Si confías en esta persona, el contenido puede ejecutar JavaScript y hacer solicitudes a la API en tu nombre usando tu sesión activa.',
            loadingMeta: 'Cargando información del archivo...',
            loadingFile: 'Cargando archivo...',
            metaError: 'No se pudo cargar la información del archivo.',
            cancel: 'Cancelar',
            trust: 'Confío, renderizar',
            back: 'Volver',
        },
    },
    en: {
        htmlViewer: {
            title: 'User content',
            createdBy: 'This HTML file was created by',
            modifiedBy: 'and last modified by',
            warning: 'If you trust this person, the content may run JavaScript and make API requests on your behalf using your active session.',
            loadingMeta: 'Loading file information...',
            loadingFile: 'Loading file...',
            metaError: 'Could not load file information.',
            cancel: 'Cancel',
            trust: 'I trust it, render',
            back: 'Go back',
        },
    },
}
